import RestockingService from '@/services/restocking.service'
import Filter from '@/models/restockingfilter.model'
import ApiService from '@/services/_api.service'
import Utils from '@/utils'
import _ from 'lodash'

const state = {
    data: {},
    dataLoading: false,
    dataPromise: null,

    amplitudePage: {
        results: [],
        count: 0,
        next: null,
        previous: null
    },
    amplitudeReading: false,
    colorAmplitudePage: {
        results: [],
        count: 0,
        next: null,
        previous: null
    },
    colorAmplitudeReading: false,

    filters: [new Filter()],

    branchNeeds: {},
    isBranchNeedsLoading: false,

    storeNeeds: {},
    isStoreNeedsLoading: false,

    dcNeeds: {},
    isDcNeedsLoading: false,

    storeDcNeeds: {},
    isStoreDcNeedsLoading: false,

    amplitudeByIdReading: false,
    amplitude: {}
}

const getters = {
    getDataPromise(state) {
        if (!state.dataLoading) return null
        return state.dataPromise
    }
}

const actions = {
    read: async ({ commit, getters }, args) => {
        // NOTE: isso pode ser usado pra carregar os gráficos
        let readPromise = getters.getDataPromise
        if (readPromise) return readPromise

        try {
            let data = RestockingService.read(args)
            commit('reading', data)
            data = await data
            commit('readSuccess', data.data)
            return null
        } catch (e) {
            commit('readFail')
            if (e && e.response) return e.response.status
            else return 500
        }
    },

    readBranchNeeds: async ({ commit }, args) => {
        try {
            commit('readingBranchNeeds')
            const response = await RestockingService.readBranchNeeds(args)
            commit('readBranchNeedsSuccess', response.data)
            return null
        } catch (e) {
            if (e && e.response) return e.response.status
            else return 500
        }
    },

    readStoreNeeds: async ({ commit }, args) => {
        try {
            commit('readingStoreNeeds')
            const response = await RestockingService.readStoreNeeds(args)
            commit('readStoreNeedsSuccess', response.data)
            return null
        } catch (e) {
            if (e && e.response) return e.response.status
            else return 500
        }
    },

    readDcNeeds: async ({ commit }, args) => {
        try {
            commit('readingDcNeeds')
            const response = await RestockingService.readDcNeeds(args)
            commit('readDcNeedsSuccess', response.data)
            return null
        } catch (e) {
            if (e && e.response) return e.response.status
            else return 500
        }
    },

    readStoreDcNeeds: async ({ commit }, args) => {
        try {
            commit('readingStoreDcNeeds')
            const response = await RestockingService.readStoreDcNeeds(args)
            commit('readStoreDcNeedsSuccess', response.data)
            return null
        } catch (e) {
            if (e && e.response) return e.response.status
            else return 500
        }
    },

    /** FILTER MANAGEMENT **/
    createFilter: async ({ commit }, args) => {
        try {
            let result = await RestockingService.createFilter(args)
            commit('createFilterSuccess', result.data)
            return null
        } catch (e) {
            if (e && e.response) return e.response.status
            else return 500
        }
    },
    readFilters: async ({ commit }, args) => {
        try {
            let data = await RestockingService.readFilters(args)
            commit('readFiltersSuccess', data.data)
            return null
        } catch (e) {
            if (e && e.response) return e.response.status
            else return 500
        }
    },
    updateFilter: async ({ commit }, args) => {
        try {
            await RestockingService.updateFilter(args.id, args)
            commit('updateFilterSuccess')
            return null
        } catch (e) {
            if (e && e.response) return e.response.status
            else return 500
        }
    },
    deleteFilter: async ({ commit }, args) => {
        try {
            await RestockingService.deleteFilter(args.id)
            commit('deleteFilterSuccess', args)
            return null
        } catch (e) {
            if (e && e.response) return e.response.status
            else return 500
        }
    },
    likeFilter: async ({ commit }, args) => {
        try {
            await RestockingService.likeFilter(args)
            commit('likeFilterSuccess', args)
            return null
        } catch (e) {
            if (e && e.response) return e.response.status
            else return 500
        }
    },
    unlikeFilter: async ({ commit }, args) => {
        try {
            await RestockingService.unlikeFilter(args)
            commit('unlikeFilterSuccess', args)
            return null
        } catch (e) {
            if (e && e.response) return e.response.status
            else return 500
        }
    },
    updateLastSeenFilter: async ({ commit }, args) => {
        try {
            await RestockingService.updateLastSeen(args)
            commit('updateLastSeenFilterSuccess', args)
            return null
        } catch (e) {
            if (e && e.response) return e.response.status
            else return 500
        }
    },

    readAmplitude: async ({ commit }, args) => {
        try {
            let data = RestockingService.readAmplitude(args)
            commit('readingAmplitude', data)
            data = await data
            commit('readAmplitudeSuccess', data.data, args.page)
            return null
        } catch (e) {
            commit('readAmplitudeFail')
            if (e && e.response) return e.response.status
            else return 500
        }
    },

    readAmplitudeById: async ({ commit }, id) => {
        if (!id) return
        try {
            commit('readingAmplitudeById')
            const amplitude = await RestockingService.readAmplitudeById(id)
            commit('readAmplitudeByIdSuccess', amplitude.data)
        } catch (e) {
            if (e && e.response) throw e.response.status
            else throw 500
        }
    },

    createAmplitude: async ({ commit }, args) => {
        try {
            let result = await RestockingService.createAmplitude(args)
            commit('createAmplitudeSuccess', result)
            return null
        } catch (e) {
            if (e && e.response) return e.response.status
            else return 500
        }
    },

    moreAmplitude: async ({ commit }, url) => {
        if (!url) return

        try {
            let page = ApiService.readUrl(url)
            commit('readingAmplitude')
            page = await page
            commit(
                'readAmplitudeMoreSuccess',
                page.data,
                new URLSearchParams(url).get('page')
            )
            return null
        } catch (e) {
            commit('readAmplitudeFail')
            if (e && e.response) return e.response.status
            else return 500
        }
    },

    readColorAmplitude: async ({ commit }, args) => {
        try {
            let data = RestockingService.readColorAmplitude(args)
            commit('readingColorAmplitude', data)
            data = await data
            commit('readColorAmplitudeSuccess', data.data, args.page)
            return null
        } catch (e) {
            commit('readColorAmplitudeFail')
            if (e && e.response) return e.response.status
            else return 500
        }
    },

    moreColorAmplitude: async ({ commit }, url) => {
        if (!url) return

        try {
            let page = ApiService.readUrl(url)
            commit('readingColorAmplitude')
            page = await page
            commit(
                'readColorAmplitudeMoreSuccess',
                page.data,
                new URLSearchParams(url).get('page')
            )
            return null
        } catch (e) {
            commit('readColorAmplitudeFail')
            if (e && e.response) return e.response.status
            else return 500
        }
    },

    clearColorAmplitude: ({ commit }, new_array = []) => {
        commit('readColorAmplitudeSuccess', new_array, null)
    },

    saveManyColorAmplitude: async ({ commit }, args) => {
        try {
            await RestockingService.saveManyColorAmplitude(args)
            commit('saveManyColorAmplitudeSuccess')
            return null
        } catch (e) {
            if (e && e.response) return e.response.status
            else return 500
        }
    }
}

const mutations = {
    reading(state, data) {
        state.dataPromise = data
        state.dataLoading = true
    },
    readSuccess(state, data) {
        state.data = data
        state.dataLoading = false
    },
    readFail(state) {
        state.dataLoading = false
        state.dataPromise = null
    },

    readAmplitudeSuccess(state, page, page_index) {
        Utils.datetimeConverter(page.results)
        state.amplitudePage = page
        state.amplitudePage.index = page_index

        state.amplitudeReading = false
    },
    readAmplitudeMoreSuccess(state, page, page_index) {
        state.amplitudeReading = false
        Utils.datetimeConverter(page.results)
        state.amplitudePage.next = page.next
        state.amplitudePage.previous = page.previous

        let current_results = _.cloneDeep(state.amplitudePage.results)
        state.amplitudePage.results = current_results.concat(page.results)

        state.amplitudePage.index = page_index
    },

    readingAmplitude(state) {
        state.amplitudeReading = true
    },

    readingAmplitudeById(state) {
        state.amplitudeByIdReading = true
    },

    readAmplitudeByIdSuccess(state, amplitude) {
        state.amplitudeByIdReading = false
        state.amplitude = amplitude
    },

    createAmplitudeSuccess(state, amplitude) {
        state.amplitude = amplitude
    },

    readAmplitudeFail(state) {
        state.amplitudeReading = false
    },

    readColorAmplitudeSuccess(state, page, page_index) {
        Utils.datetimeConverter(page.results)
        state.colorAmplitudePage = page
        state.colorAmplitudePage.index = page_index

        state.colorAmplitudeReading = false
    },
    readColorAmplitudeMoreSuccess(state, page, page_index) {
        state.colorAmplitudeReading = false
        Utils.datetimeConverter(page.results)
        state.colorAmplitudePage.next = page.next
        state.colorAmplitudePage.previous = page.previous

        let current_results = _.cloneDeep(state.colorAmplitudePage.results)
        state.colorAmplitudePage.results = current_results.concat(page.results)

        state.colorAmplitudePage.index = page_index
    },

    readingColorAmplitude(state) {
        state.colorAmplitudeReading = true
    },

    readColorAmplitudeFail(state) {
        state.colorAmplitudeReading = false
    },

    saveManyColorAmplitudeSuccess(state) {},

    createFilterSuccess(state, data) {
        var filters = _.cloneDeep(state.filters)
        filters.push(data)

        var filter_filtered = filters
            .filter(elem => elem.id != null)
            .map(a => {
                if (a.id === data) {
                    a.datetime_last_seen = new Date().toISOString()
                }
                return a
            })
            .sort(
                (a, b) =>
                    new Date(b.datetime_last_seen).getTime() -
                    new Date(a.datetime_last_seen).getTime()
            )
        filter_filtered = filter_filtered.concat(
            filters.filter(elem => elem.id == null)
        )

        state.filters = filter_filtered
    },
    readFiltersSuccess(state, data) {
        state.filters = data //.sort((a, b) => (new Date(a.datetime_updated)).getTime() - (new Date(b.datetime_updated)).getTime())
        state.filters.push(new Filter()) // add default filter to the end
    },
    updateFilterSuccess(state) {},

    deleteFilterSuccess(state, args) {
        state.filters = state.filters.filter(elem => elem.id != args.id)
    },

    likeFilterSuccess(state, data) {
        state.filters = state.filters.map(a => {
            if (a.id === data) {
                a.liked = true
            }
            return a
        })
    },
    unlikeFilterSuccess(state, data) {
        state.filters = state.filters.map(a => {
            if (a.id === data) {
                a.liked = false
            }
            return a
        })
    },

    updateLastSeenFilterSuccess(state, data) {
        state.filters = state.filters
            .map(a => {
                if (a.id === data) {
                    a.datetime_last_seen = new Date().toISOString()
                }
                return a
            })
            .sort(
                (a, b) =>
                    new Date(b.datetime_last_seen).getTime() -
                    new Date(a.datetime_last_seen).getTime()
            )
    },

    readingBranchNeeds(state, data) {
        state.isBranchNeedsLoading = true
    },

    readBranchNeedsSuccess(state, page) {
        state.branchNeeds = page
        state.isBranchNeedsLoading = false
    },

    readingStoreNeeds(state, data) {
        state.isStoreNeedsLoading = true
    },

    readStoreNeedsSuccess(state, page) {
        state.storeNeeds = page
        state.isStoreNeedsLoading = false
    },

    readingDcNeeds(state, data) {
        state.isDcNeedsLoading = true
    },

    readDcNeedsSuccess(state, page) {
        state.dcNeeds = page
        state.isDcNeedsLoading = false
    },

    readingStoreDcNeeds(state, data) {
        state.isStoreDcNeedsLoading = true
    },

    readStoreDcNeedsSuccess(state, page) {
        state.storeDcNeeds = page
        state.isStoreDcNeedsLoading = false
    }
}

const restocking = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}

export default restocking
export { restocking }
